import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState('light');

  useEffect(() => {
    localStorage.setItem('rishant-theme', theme);
    document.documentElement.setAttribute('data-theme', theme);

    const root = document.documentElement;

    if (theme === 'dark') {
      root.style.setProperty('--color-bg', '#111111');
      root.style.setProperty('--color-bg-card', '#1A1A1A');
      root.style.setProperty('--color-bg-section', '#0A0A0A');
      root.style.setProperty('--color-surface', '#1A1A1A');
      root.style.setProperty('--color-border', '#2A2A2A');
      root.style.setProperty('--color-text-primary', '#FFFFFF');
      root.style.setProperty('--color-text-body', '#CCCCCC');
      root.style.setProperty('--color-text-muted', '#888888');
    } else {
      root.style.setProperty('--color-bg', '#F5F0E8');
      root.style.setProperty('--color-bg-card', '#FFFFFF');
      root.style.setProperty('--color-bg-section', '#FAF7F2');
      root.style.setProperty('--color-surface', '#FFFFFF');
      root.style.setProperty('--color-border', '#E0D8CC');
      root.style.setProperty('--color-text-primary', '#1A1A1A');
      root.style.setProperty('--color-text-body', '#333333');
      root.style.setProperty('--color-text-muted', '#666666');
    }
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev => prev === 'dark' ? 'light' : 'dark');
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
